import React from "react";
import { Progress } from "react-sweet-progress";
import { css } from "emotion";

function ProgressBar(props) {
  const { percent = 0, trailColor = "inherit" } = props;

  const styles = {
    root: css`
      .react-sweet-progress {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 100%;
      }

      .react-sweet-progress-symbol {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: start;
        justify-content: flex-start;
        /* width: 35px; */
        height: 20px;
        /* padding-left: 10px; */
        color: rgba(0, 0, 0, 0.7);
        font-weight: 200;
      }

      /* .react-sweet-progress-symbol-absolute {
        display: -ms-flexbox;
        display: flex;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        transform: translate3d(-50%, -50%, 0);
      } */
      .react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {
        padding: 0;
        width: 100%;
      }

      .react-sweet-progress-circle-outer {
        position: relative;
        display: inline-block;
        vertical-align: middle;
      }
      .react-sweet-progress-line {
        width: 100%;
        border-radius: 100px;
        background-color: #efefef;
        vertical-align: middle;
      }
      .react-sweet-progress-line-inner {
        position: relative;
        min-height: 10px;
        border-radius: 100px;
        transition: width 0.3s ease;
      }

      .react-sweet-progress-line-inner-status-active:before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 10px;
        background: #fff;
        animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;
        content: "";
        opacity: 0;
      }

      @keyframes active-anim {
        0% {
          width: 0;
          opacity: 0.1;
        }
        20% {
          width: 0;
          opacity: 0.5;
        }
        to {
          width: 100%;
          opacity: 0;
        }
      }
      .react-sweet-progress-circle path {
        stroke-linecap: round;
      }
    `,
  };

  const colors = [
    "#FF043F",
    "#EB1646",
    "#D7274D",
    "#C33954",
    "#AF4B5B",
    "#9C5D62",
    "#886E68",
    "#74806F",
    "#609276",
    "#4CA37D",
    "#38B584",
  ];

  return (
    <div className={styles.root}>
      <Progress
        percent={percent}
        status={`${percent}`}
        theme={{
          default: {
            symbol: " ",
            trailColor,
            color: colors[0],
          },
          0: {
            symbol: " ",
            trailColor,
            color: colors[0],
          },
          10: {
            symbol: " ",
            trailColor,
            color: colors[1],
          },
          20: {
            symbol: " ",
            trailColor,
            color: colors[2],
          },
          30: {
            symbol: " ",
            trailColor,
            color: colors[3],
          },
          40: {
            symbol: " ",
            trailColor,
            color: colors[4],
          },
          50: {
            symbol: " ",
            trailColor,
            color: colors[5],
          },
          60: {
            symbol: " ",
            trailColor,
            color: colors[6],
          },
          70: {
            symbol: " ",
            trailColor,
            color: colors[7],
          },
          80: {
            symbol: " ",
            trailColor,
            color: colors[8],
          },
          90: {
            symbol: " ",
            trailColor,
            color: colors[9],
          },
          100: {
            symbol: " ",
            trailColor,
            color: colors[10],
          },
        }}
      />
    </div>
  );
}

export default ProgressBar;
